const isRelativeUrl = (url: string): boolean => {
	return url.startsWith('/') && !url.startsWith('//');
};

export const checkSameHostUrl = (host: string, url: string): boolean => {
	if (isRelativeUrl(url)) {
		return true;
	}

	try {
		const urlHost = new URL(url).host;
		return urlHost === host;
	} catch {
		// Keep this check fail-safe for malformed CMS URLs without polluting browser console.
		return false;
	}
};
